import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import TextField from '../../../component/form/TextField';
import SearchIcon from '../../../component/icon/SearchIcon';
import InputAdornment from '@mui/material/InputAdornment';

class SearchWithButton extends Component {
    state = {
        searchWords: this.props.searchKeyword
    };

    render() {
        const { placeholder, className } = this.props;

        return (
            <div className="search-field">
                <form onSubmit={this.onSearchSubmit}>
                    <TextField
                        placeholder={placeholder}
                        className={className}
                        type="search"
                        InputProps={{
                            disableUnderline: true,
                            endAdornment: (
                                <InputAdornment position={'end'}>
                                    <div className="input-adornment--end" onClick={this.onSearchSubmit}>
                                        <SearchIcon />
                                    </div>
                                </InputAdornment>
                            ),
                            inputProps: {
                                ref: this.onSearchFieldRef
                            }
                        }}
                        onChange={e => this.setState({ searchWords: e.target.value })}
                        value={this.state.searchWords}
                    />
                </form>
            </div>
        );
    }

    onSearchSubmit = e => {
        if (e) e.preventDefault();

        if (this.searchFieldInput) {
            let { onSearchSubmit } = this.props;
            if (onSearchSubmit) {
                onSearchSubmit(this.searchFieldInput.value);
            }
        }
    };

    onSearchFieldRef = input => {
        this.searchFieldInput = input;
    };
}

export default withStyles({})(SearchWithButton);
